import { msg } from '@lingui/core/macro'
import { createFileRoute } from '@tanstack/react-router'
import { useProjectDetail } from '~/components/projects/project-detail'
import { decodeTasksSearch } from '~/components/tasks/search'
import { TaskBoard } from '~/components/tasks/task-board'
import { titleFor } from '~/lib/route-title'

/**
 * The project's own task board — the SAME board the workspace Tasks page
 * mounts, hard-scoped to this project. Filters, views and quick-adds all
 * behave identically; only the project dimension is pinned and the page
 * header is the project's.
 */
const ProjectTasksRoute = () => {
  const project = useProjectDetail()

  return <TaskBoard scope={{ projectId: project._id }} />
}

export const Route = createFileRoute('/_authenticated/$workspaceSlug/projects/$projectId/tasks')({
  component: ProjectTasksRoute,
  head: () => ({ meta: [{ title: titleFor(msg`Tasks`) }] }),
  validateSearch: decodeTasksSearch,
})
